import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateGroup = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Institution'
      fields={fields}
      apiPath='admin/institutions'
      successRedirectPath={resource => `/membership/institutions/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateGroup
